import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  size?:
    | 'max-w-sm'
    | 'max-w-md'
    | 'max-w-lg'
    | 'max-w-xl'
    | 'max-w-2xl'
    | 'max-w-3xl'
    | 'max-w-4xl'
    | 'max-w-5xl'
    | 'max-w-6xl'
    | 'max-w-7xl'
    | 'max-w-full';
}

export const Modal = ({
  open,
  onClose,
  children,
  size = 'max-w-lg',
}: ModalProps) => {
  return (
    <Dialog
      transition
      open={open}
      onClose={onClose}
      className="fixed inset-0 flex w-screen items-center justify-center p-4 transition duration-300 ease-out data-[closed]:opacity-0"
    >
      <DialogBackdrop className="fixed inset-0 bg-black/15" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className={`space-y-4 border bg-white w-full ${size} rounded-xl max-h-[90vh] overflow-y-auto`}>
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
};
